import request from "@/utils/request";
export default {
  // 分页查询
  getAuditorData: (param) => {
    return request({
      url: `/rmc/protein/auditor/list`,
      method: "post",
      data: param,
    });
  },
  // 农场明细
  getAuditorDetail: (rmcProteinAuditorId) => {
    return request({
      url: `/rmc/protein/auditor/detail/${rmcProteinAuditorId}`,
      method: "post",
      data: {},
    });
  },
  // 新增
  addAuditor: (param) => {
    return request({
      url: `/rmc/protein/auditor/create`,
      method: "post",
      data: param,
    });
  },
  // 更新
  updateAuditor: (rmcProteinAuditorId, param) => {
    return request({
      url: `/rmc/protein/auditor/update/${rmcProteinAuditorId}`,
      method: "post",
      data: param,
    });
  },
  // 提交
  submitAuditor: (rmcProteinAuditorId, param) => {
    return request({
      url: `/rmc/protein/auditor/submit/${rmcProteinAuditorId}`,
      method: "post",
      data: param,
    });
  },
  // 批量提交
  submitBtach: (param) => {
    return request({
      url: `/rmc/protein/auditor/submit`,
      method: "post",
      data: param,
    });
  },
  // Farm退回
  returnAuditor: (param) => {
    return request({
      url: `/rmc/protein/auditor/return`,
      method: "post",
      data: param,
    });
  },
  // Farm批准
  approveAuditor: (param) => {
    return request({
      url: `/rmc/protein/auditor/approve`,
      method: "post",
      data: param,
    });
  },
  // Farm删除
  deleteAuditor: (param) => {
    return request({
      url: `/rmc/protein/auditor/delete`,
      method: "post",
      data: param,
    });
  },
  // Farm确认无更新
  confirmNoChange: (param) => {
    return request({
      url: `/rmc/protein/auditor/confirmNoChange`,
      method: "post",
      data: param,
    });
  },
  // 更新日志列表
  updateLog: (param) => {
    return request({
      url: `/rmc/protein/auditor/updateLog`,
      method: "post",
      data: param,
    });
  },
  // 导出审核员清单
  downloadAuditorLists: (param) => {
    return request({
      url: `/rmc/protein/auditor/downloadAuditorList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出更新日志
  downloadUpdateLogList: (param) => {
    return request({
      url: `/rmc/protein/auditor/downloadUpdateLogList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 查询ASL Group
  getAslGroupList: (sponsor) => {
    return request({
      url: `/rmc/protein/asl/aslGroupList?sponsor=${sponsor}`,
      method: "post",
      data: {},
    });
  },
  // 获取sponsor
  getSponsorByUser: () => {
    return request({
      url: `/rmc/protein/medicine/getSponsorByUser`,
      method: "post",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // 获取授权的Category3
  getAuthorizedCategory3: () => {
    return request({
      url: `/rmc/protein/farm/authorizedCategory3`,
      method: "get",
    });
  },
  // 导出季度审核员清单
  downloadAuditorQuarterList: (param) => {
    return request({
      url: `/rmc/protein/auditor/downloadAuditorQuarterList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
